<template>
  <router-view />
</template>

<script>
export default {
  name: "app-users"
};
</script>

<style lang="scss" scoped></style>
